webpackJsonp([9],{

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    isAuthenticated: function isAuthenticated(state) {
        return !!state.token && !!state.user;
    }
});

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    AUTH_SUCCESS: function AUTH_SUCCESS(state, _ref) {
        var token = _ref.token,
            user = _ref.user;

        state.token = token;
        state.user = user;
    },
    authError: function authError(state) {
        state.token = null;
        state.user = null;
    },
    AUTH_LOGOUT: function AUTH_LOGOUT(state) {
        state.token = null;
        state.user = null;
    },
    setTitle: function setTitle(state, title) {
        state.title = title;
    },
    enableNavigationTabs: function enableNavigationTabs(state, value) {
        state.appConfig.enableNavigationTabs = value;
    },
    backButtonRequired: function backButtonRequired(state, value) {
        state.appConfig.backButtonRequired = value;
    },
    SET_EXPENSES: function SET_EXPENSES(state, list) {
        state.entriesList = list;
    },
    setGroupsList: function setGroupsList(state, list) {
        state.groupsList = list;
    }
});

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
    authRequest: function authRequest(_ref, _ref2) {
        var _this = this;

        var commit = _ref.commit;
        var email = _ref2.email,
            password = _ref2.password;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var res, token, user;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* login */])({ email: email, password: password });

                        case 3:
                            res = _context.sent;
                            token = res.data.data.token;
                            user = res.data.data.user;

                            commit("AUTH_SUCCESS", { token: token, user: user });
                            _context.next = 15;
                            break;

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](0);

                            commit("authError");
                            _context.next = 14;
                            return localStorage.clear();

                        case 14:
                            throw _context.t0;

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[0, 9]]);
        }))();
    },
    register: function register(_ref3, _ref4) {
        var _this2 = this;

        var commit = _ref3.commit;
        var name = _ref4.name,
            email = _ref4.email,
            password = _ref4.password;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            var res, user, token;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* register */])({ name: name, email: email, password: password });

                        case 2:
                            res = _context2.sent;
                            user = res.data.data.user;
                            token = res.data.data.token;

                            commit("AUTH_SUCCESS", { token: token, user: user });

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    AUTH_LOGOUT: function AUTH_LOGOUT(_ref5) {
        var _this3 = this;

        var commit = _ref5.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            commit("AUTH_LOGOUT");
                            delete __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['x-access-token'];

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    },
    getExpenses: function getExpenses(_ref6) {
        var _this4 = this;

        var commit = _ref6.commit;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var expenses, expensesArr;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;
                            _context4.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_2__api__["c" /* secure */].getExpenses();

                        case 3:
                            expenses = _context4.sent;

                            console.log('expenses: ', expenses);
                            expensesArr = expenses.data.data || [];

                            commit('SET_EXPENSES', expensesArr);
                            _context4.next = 13;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](0);

                            console.error('Error while performing SET_EXPENSES: ', _context4.t0);
                            throw _context4.t0;

                        case 13:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4, [[0, 9]]);
        }))();
    }
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_data__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_data__);




var deleteExpense = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(expenseId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_4__config_js___default.a.baseURL + '/expense/' + expenseId));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function deleteExpense(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getExpenses = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_js___default.a.baseURL + '/expense'));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getExpenses() {
    return _ref2.apply(this, arguments);
  };
}();

var saveEntry = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(expenseForm) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config_js___default.a.baseURL + '/expense', expenseForm));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function saveEntry(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var getGroups = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_js___default.a.baseURL + '/group'));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getGroups() {
    return _ref4.apply(this, arguments);
  };
}();

var getCategories = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(groupId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_js___default.a.baseURL + '/group/' + groupId + '/category'));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function getCategories(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

var getGroupMemebers = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(groupId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_js___default.a.baseURL + '/group/' + groupId + '/member'));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function getGroupMemebers(_x4) {
    return _ref6.apply(this, arguments);
  };
}();






// This block intercepts all axios requests and appends token
// headers 
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  config.headers.common['x-access-token'] = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.token;
  return config;
}, function (error) {
  console.error('Error setting access token before api request: ', error);
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
  deleteExpense: deleteExpense,
  getCategories: getCategories,
  getExpenses: getExpenses,
  getGroupMemebers: getGroupMemebers,
  getGroups: getGroups,
  saveEntry: saveEntry
});

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

var expenses = [{ "id": 1, "category": "Cumin - Whole", "amount": "4.86", "details": "Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus. Pellentesque at nulla. Suspendisse potenti. Cras in purus eu magna vulputate luctus. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.", "paidBy": "Fergus", "paidOn": "9/3/2017", "paidInGroup": "Skinix" }, { "id": 2, "category": "Flour - Fast / Rapid", "amount": "4.15", "details": "Vivamus tortor. Duis mattis egestas metus. Aenean fermentum. Donec ut mauris eget massa tempor convallis. Nulla neque libero, convallis eget, eleifend luctus, ultricies eu, nibh. Quisque id justo sit amet sapien dignissim vestibulum.", "paidBy": "Anatol", "paidOn": "9/9/2017", "paidInGroup": "Realcube" }, { "id": 3, "category": "Oil - Truffle, White", "amount": "1.23", "details": "Duis mattis egestas metus. Aenean fermentum. Donec ut mauris eget massa tempor convallis.", "paidBy": "Alessandro", "paidOn": "5/21/2018", "paidInGroup": "Aivee" }, { "id": 4, "category": "Cake - Dulce De Leche", "amount": "6.05", "details": "Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet.", "paidBy": "Eben", "paidOn": "6/8/2018", "paidInGroup": "Voonder" }]; //shape: [{id, amount, category, details, paidBy, paidOn, paidInGroup}]
var GROUPS_STORAGE_KEY = "GE_Groups_Store";
var EXPENSES_STORAGE_KEY = "GE_Expense_Store";
var GLOBAL_STORAGE_KEY = "GE_Global_store";

module.exports = {
    expenses: expenses,
    GROUPS_STORAGE_KEY: GROUPS_STORAGE_KEY,
    EXPENSES_STORAGE_KEY: EXPENSES_STORAGE_KEY,
    GLOBAL_STORAGE_KEY: GLOBAL_STORAGE_KEY
};

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_constants__);



var localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, _ref) {
    var token = _ref.token,
        user = _ref.user,
        entriesList = _ref.entriesList;

    if (mutation.type === 'AUTH_SUCCESS') {
      window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__utils_constants___default.a.TOKEN, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(token));
      window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__utils_constants___default.a.USER, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
    } else if (mutation.type === 'SET_EXPENSES') {
      window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__utils_constants___default.a.EXPENSES, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(entriesList));
    } else if (mutation.type === 'AUTH_LOGOUT') {
      window.localStorage.clear();
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ([localStoragePlugin]);

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AddExpense.vue": [
		136,
		5
	],
	"./App.vue": [
		30
	],
	"./ExpenseDetail.vue": [
		137,
		0
	],
	"./ExpenseListItem.vue": [
		134,
		6
	],
	"./ExpensesView.vue": [
		138,
		1
	],
	"./GroupListItem.vue": [
		135,
		7
	],
	"./GroupsView.vue": [
		139,
		2
	],
	"./LoginView.vue": [
		140,
		4
	],
	"./RegisterView.vue": [
		141,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 127;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_constants__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    token: JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__utils_constants___default.a.TOKEN)) || '',
    user: JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__utils_constants___default.a.USER)) || {},
    title: 'Group Expenses',
    groupsList: JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__utils_constants___default.a.GROUPS)) || [],
    entriesList: JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__utils_constants___default.a.EXPENSES)) || [],
    appConfig: {
        enableNavigationTabs: false,
        backButtonRequired: false
    }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    strict: true,
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */],
    plugins: __WEBPACK_IMPORTED_MODULE_5__plugins__["a" /* default */]
}));

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(31);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d671bfc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(97);
function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var normalizeComponent = __webpack_require__(54)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d671bfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d671bfc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  computed: {
    title: function title() {
      return this.$store.state.title;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.toggleBackButton(to);
      this.toggleNavigationTabs(to);
      // Set title based on routes
      this.$store.commit("setTitle", to.meta.title);
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push('/home');
    },
    goHome: function goHome() {
      this.$router.replace('/home');
    },
    login: function login() {
      this.$router.push('/login');
    },
    logout: function logout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("AUTH_LOGOUT");

              case 2:
                _this.$router.push('/');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toggleBackButton: function toggleBackButton(route) {
      var routeName = route.name;
      this.$store.commit("backButtonRequired", this.isBackButtonRequired(routeName));
    },
    isBackButtonRequired: function isBackButtonRequired(routeName) {
      var arrayOfViewsWithoutBackButton = ['index', 'login', 'register', 'home', 'groups'];
      return !arrayOfViewsWithoutBackButton.includes(routeName);
    },
    toggleNavigationTabs: function toggleNavigationTabs(route) {
      var routeName = route.name;
      this.$store.commit("enableNavigationTabs", this.isNavigationTabRequired(routeName));
    },
    isNavigationTabRequired: function isNavigationTabRequired(routeName) {
      var arrayOfViewsWithoutNavTabs = ['home', 'groups'];
      return arrayOfViewsWithoutNavTabs.includes(routeName);
    }
  }
});

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

var IS_PRODUCTION = "production" === 'production';
var REST_API = 'https://group-expenses.herokuapp.com';
var LOCALHOST = 'http://localhost:3000';
module.exports = {
  baseURL: IS_PRODUCTION ? REST_API : LOCALHOST
};

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

module.exports = {
    TOKEN: 'GE_token',
    USER: 'GE_user',
    EXPENSES: 'GE_expenses',
    GRUOPS: 'GE_groups'
};

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_secure__ = __webpack_require__(122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__api_secure__["a"]; });




function register(credentials) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_js___default.a.baseURL + '/register', credentials);
};

function login(credentials) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__config_js___default.a.baseURL + '/login', credentials);
}



/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_css__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_theme_default_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdButton"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdContent"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdTabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdApp"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdAutocomplete"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdAvatar"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdDatepicker"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdDivider"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdElevation"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdEmptyState"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdField"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdIcon"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdImage"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdLayout"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdList"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdMenu"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdProgress"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdRipple"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdSnackbar"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdSubheader"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdToolbar"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdCard"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components__["MdDialog"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
Object(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__components_App__["default"] }
});

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container",attrs:{"id":"app"}},[_c('md-app',[_c('md-app-toolbar',{staticClass:"md-primary",on:{"click":_vm.goHome}},[_c('div',{staticClass:"md-toolbar-section-start"},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.appConfig.backButtonRequired),expression:"this.$store.state.appConfig.backButtonRequired"}],staticClass:"md-icon-button",nativeOn:{"click":function($event){return _vm.goBack($event)}}},[_c('md-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.$store.getters.isAuthenticated),expression:"this.$store.getters.isAuthenticated"}],staticClass:"md-toolbar-section-end"},[_c('md-menu',{attrs:{"md-direction":"bottom-start"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',[_vm._v("\n              Hi, there\n            ")]),_vm._v(" "),_c('md-divider'),_vm._v(" "),_c('md-menu-item',{on:{"click":_vm.logout}},[_vm._v("Logout")])],1)],1)],1)]),_vm._v(" "),_c('md-app-content',[_c('md-tabs',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.appConfig.enableNavigationTabs),expression:"this.$store.state.appConfig.enableNavigationTabs"}],attrs:{"md-sync-route":"","md-alignment":"fixed","md-active-tab":"tab-home"}},[_c('md-tab',{attrs:{"id":"tab-home","md-label":"All","to":"home"}}),_vm._v(" "),_c('md-tab',{attrs:{"id":"tab-groups","md-label":"Groups","to":"groups"}})],1),_vm._v(" "),_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(26);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/**
 * Function to dynamically import a Vue component
 * @param {any} view 
 * @returns 
 */
function loadView(view) {
  return function () {
    return __webpack_require__(127)("./" + view + '.vue');
  };
}

var ifNotAuthenticated = function ifNotAuthenticated(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/home');
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'index',
    component: loadView('LoginView'),
    meta: { title: "Group Expenses" },
    beforeEnter: ifNotAuthenticated
  }, {
    path: '/register',
    name: 'register',
    meta: { title: "Register" },
    component: loadView('RegisterView'),
    beforeEnter: ifNotAuthenticated
  }, {
    path: '/login',
    name: 'login',
    meta: { title: "Login" },
    component: loadView('LoginView'),
    beforeEnter: ifNotAuthenticated
  }, {
    path: '/home',
    name: 'home',
    meta: { title: "Expenses" },
    component: loadView('ExpensesView'),
    beforeEnter: ifAuthenticated
  }, {
    path: '/expense/:id',
    name: 'expense',
    meta: { title: "Expense" },
    component: loadView('ExpenseDetail'),
    beforeEnter: ifAuthenticated
  }, {
    path: '/new-expense',
    name: 'newExpense',
    meta: { title: "Add a bill" },
    component: loadView('AddExpense'),
    beforeEnter: ifAuthenticated
  }, {
    path: '/groups',
    name: 'groups',
    meta: { title: 'Group Expenses' },
    component: loadView('GroupsView'),
    beforeEnter: ifAuthenticated
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ })

},[56]);


// WEBPACK FOOTER //
// static/js/app.c8e08df39633d2915793.js